module.exports = __webpack_public_path__ + "img/04-5.61c99601.png";